import { getBanksForCountry, resolveBankLogo as resolveLogo } from '@/data/locales';

export { getBanksForCountry, BANKS_BY_COUNTRY } from '@/data/locales';

/** @deprecated Prefer getBanksForCountry('PK') */
export const PAKISTAN_BANKS = getBanksForCountry('PK');

export function resolveBankLogo(bankName: string, logoUrl?: string | null, country?: string | null): string {
  return resolveLogo(bankName, logoUrl, country || 'PK');
}
